var _require = require('crypto'),
    signOneShot = _require.sign,
    verifyOneShot = _require.verify;

var _require2 = require('../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var _require3 = require('../help/runtime_support'),
    edDSASupported = _require3.edDSASupported;

var sign = function sign(_ref, payload) {
  var keyObject = _ref[KEYOBJECT];

  if (typeof payload === 'string') {
    payload = Buffer.from(payload);
  }

  return signOneShot(undefined, payload, keyObject);
};

var verify = function verify(_ref2, payload, signature) {
  var keyObject = _ref2[KEYOBJECT];
  return verifyOneShot(undefined, payload, keyObject, signature);
};

module.exports = function (JWA, JWK) {
  if (edDSASupported) {
    JWA.sign.set('EdDSA', sign);
    JWA.verify.set('EdDSA', verify);

    JWK.OKP.sign.EdDSA = function (key) {
      return key.private && JWK.OKP.verify.EdDSA(key);
    };

    JWK.OKP.verify.EdDSA = function (key) {
      return (key.use === 'sig' || key.use === undefined) && key.keyObject.asymmetricKeyType.startsWith('ed');
    };
  }
};